import * as actionType from "../Actions/Action_Type";

const initialState = {
    isFetching      : false,
    errorMessage    : null,
    isTokenValid    : null,
    passwordChanged : false,
};

const recoverReducer = (state = initialState, action) => {

    switch (action.type){
        case actionType.SERVICE_RECOVER_VALIDATION_TOKEN_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
        case actionType.SERVICE_RECOVER_VALIDATION_TOKEN_SUCCESS :
            return Object.assign({}, state, {
                isFetching      : false,
                isTokenValid    : true,
                isAuthenticated : true
            })
        case actionType.SERVICE_RECOVER_VALIDATION_TOKEN_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null,
                isTokenValid : false,
            })
            
        case actionType.SERVICE_RECOVER_SET_PASSWORD_REQUEST: 
            return Object.assign({}, state, {
                isFetching : true,
                goToLogin : true
            })
        case actionType.SERVICE_RECOVER_SET_PASSWORD_SUCCESS: 
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : null,
                passwordChanged : true,
                goToLogin : true
            })
        case actionType.SERVICE_RECOVER_SET_PASSWORD_ERROR: 
            return Object.assign({}, state, {
                isFetching : false,
                errorMessage : action.error || null,
                goToLogin : false
            })
        default:
            return state;
    }
};

export default recoverReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_RecuperaPassword.js